import {
  collection, doc, addDoc, deleteDoc,
  query, where, orderBy, onSnapshot, serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { applyRoleFilter, getOwnershipFields } from './dataFilterHelper';

const COLLECTION = 'simulations';

// ======== CRIAR SIMULAÇÃO ========
export const createSimulation = async (userId, clientId, data, profile) => {
  const ownership = profile ? getOwnershipFields(profile) : { userId, masterId: userId, gestorId: userId };
  return addDoc(collection(db, COLLECTION), {
    ...data,
    ...ownership,
    clientId: clientId || null,
    criadoEm: serverTimestamp(),
  });
};

// ======== LISTAR SIMULAÇÕES (com filtro por role) ========
export const subscribeSimulationsByRole = (profile, callback) => {
  const baseQuery = query(collection(db, COLLECTION), orderBy('criadoEm', 'desc'));
  const filtered = applyRoleFilter(baseQuery, profile);
  return onSnapshot(filtered, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

// Versão legada (por userId) — mantida para compatibilidade
export const subscribeUserSimulations = (userId, callback) => {
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId),
    orderBy('criadoEm', 'desc')
  );
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

// ======== EXCLUIR SIMULAÇÃO ========
export const deleteSimulation = async (simId) => {
  return deleteDoc(doc(db, COLLECTION, simId));
};